import { Statistic } from 'antd'

import styles from './styles.css'
const CustomClearanceTimer = (props: { htsDueDate: any }) => {
    const { htsDueDate } = props

    return (
        <>
            <Statistic.Countdown
                value={htsDueDate}
                format="H hour[s] m [m]inute[s]"
                className={styles.customClearanceTimer}
            />{' '}
        </>
    )
}

export default CustomClearanceTimer
